import { TDisplayScreen } from '@/types';

export function canDisplayContentOnScreen(isSmallScreen: boolean, displayScreen: TDisplayScreen = 'Both'): boolean {
	switch (displayScreen) {
		case 'Desktop':
			return !isSmallScreen;
		case 'Mobile':
			return isSmallScreen;
		case 'Hide':
			return false;
		case 'Both':
		default:
			return true;
	}
}
